import axios from 'axios'
import { url } from './global'

export const buildHistorialStockUrl = (sucursalId, articuloId, filters) => {
    let href = `${url}/v2/historial-stock?sucursal=${sucursalId}&articulo=${articuloId}`
    if (!filters) return href
    if (filters.from) href += `&from=${filters.from}`
    if (filters.to) href += `&to=${filters.to}`
    if (Array.isArray(filters.motivoNotIn)) {
        filters.motivoNotIn.forEach((motivo) => {
            href += `&motivoNotIn=${motivo}`
        })
    }
    if (filters.size != null && filters.size !== '') {
        href += `&size=${filters.size}`
    }
    return href
}

export const historialMovimientosFromResponse = (res) => {
    if (!res || !res.data || !Array.isArray(res.data.movimientos)) return []
    return res.data.movimientos
}

export const isHistorialTruncated = (res) =>
    Boolean(res && res.data && res.data.truncated)

export const getHistorialStockByArticulo = async (
    sucursalId,
    articuloId,
    filters
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        buildHistorialStockUrl(sucursalId, articuloId, filters),
        { headers }
    )
    return res
}

export const getAllStockSucursalPage = async (stockSucursal, id) => { }

export const saveStockSucursal = async (stockSucursal) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.post(`${url}/v2/stocks`, stockSucursal, { headers })
    return res
}

export const getAllStockSucursal = async (
    activo,
    page,
    sucursal,
    lista,
    codigoBarra,
    codigo,
    nombre,
    size = 50
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/stocks?${nombre ? `nombre=${nombre}&` : ''}${lista ? `lista=${lista}&` : ''}${codigoBarra ? `codigoBarra=${codigoBarra}&` : ''}${codigo ? `codigo=${codigo}&` : ''}activo=${activo}&page=${page}&size=${size}&sucursal=${sucursal}`,
        { headers }
    )
    return res
}

export const getStockSucursalById = async (sucursalId, articuloId, listaId) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/stocks/sucursal/${sucursalId}/articulo/${articuloId}?${listaId ? `lista=${listaId}&` : ''}`,
        { headers }
    )
    return res
}

export const getStockSucursalByCodigo = async (sucursalId, codigo, listaId) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    let res = await axios.get(
        `${url}/v2/stocks/sucursal/${sucursalId}/articulo/1?${listaId ? `lista=${listaId}&` : ''}&codigo=${codigo}`,
        { headers }
    )
    return res
}

export const editByIdStockSucursal = async (sucursalId, articuloId, values) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.put(
        `${url}/v2/stocks/sucursal/${sucursalId}/articulo/${articuloId}`,
        values,
        { headers }
    )
    return res
}

export const deleteStockSucursal = async (idSucursal, idArticulo) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.delete(
        `${url}/v2/stocks/sucursal/${idSucursal}/articulo/${idArticulo}`,
        { headers }
    )
    return res
}

export const recoverStockSucursal = async (idSucursal, idArticulo) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.put(
        `${url}/v2/stocks/sucursal/${idSucursal}/articulo/${idArticulo}/recover`,
        {},
        { headers }
    )
    return res
}

// IMPORT STOCK
export const saveStockImportar = async (data) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'multipart/file',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.post(`${url}/v2/stocks/importar`, data, {
        headers,
    })
    return res
}
